import { Fragment, useRef, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { AIIcon } from '@setvi/shared/components/sicons';

import AIloader from 'componentsV2/ai/loader';

import { AskPdfProps, ConversationProps } from '../..';
import { AITextarea, Placeholder } from './components';
import {
  AIBox,
  ChatContent,
  Content,
  IconBox,
  Message,
  TextareaBox,
  UserBox
} from './styled';

interface ChatProps extends Partial<AskPdfProps> {
  conversation: ConversationProps[];
  questions: string[];
  loading: boolean;

  onSubmit: (val: string) => void;
}

const Chat = ({
  id,
  name,
  typeId,
  loading,
  questions,
  thumbnail,
  conversation,
  onSubmit
}: ChatProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [conversation]);

  return (
    <>
      <Content
        style={{
          height: conversation?.length ? 'calc(100% - 100px)' : '100%'
        }}
        // @ts-ignore
        ref={contentRef}>
        {!conversation?.length ? (
          <Placeholder
            questions={questions}
            onClick={onSubmit}
            thumbnail={thumbnail}
            typeId={typeId}
            name={name}
            id={id}
          />
        ) : (
          <ChatContent>
            {conversation?.map(({ question, answer }) => (
              <Fragment key={uuidv4()}>
                <UserBox>
                  <Message>{question}</Message>
                </UserBox>

                <AIBox
                  style={{
                    alignItems:
                      loading && !answer?.trim() ? 'center' : 'flex-start'
                  }}>
                  <IconBox>
                    <AIIcon fontSize="small" />
                  </IconBox>
                  {loading && !answer?.trim() ? (
                    <AIloader />
                  ) : (
                    <Message
                      dangerouslySetInnerHTML={{ __html: answer }}
                      style={{
                        background: '#F0F0F4'
                      }}>
                      {/* {answer} */}
                    </Message>
                  )}
                </AIBox>
              </Fragment>
            ))}
          </ChatContent>
        )}
      </Content>

      {!!conversation?.length && (
        <TextareaBox>
          <AITextarea onSubmit={onSubmit} width="60%" />
        </TextareaBox>
      )}
    </>
  );
};

export default Chat;
